import TicketsInfo from './TicketsInfo'

export default TicketsInfo
